import * as React from 'react';
import { RouteComponentProps, Prompt } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { Input } from '@progress/kendo-react-inputs';
import { fetchApi } from '../../services/api';
import LoadingButton from '../LoadingButton';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    userId: string
}>

type State = {
    isLoading: boolean;
    isDirty: boolean;
    Validation: boolean;

    user: UserData|undefined;
}

type UserData = {
    UserID: string;
    FirstName: string;
    LastName: string
    UserName: string;
    Email: string;
    IsAdmin: boolean;
    IsLockedout: boolean;
    ReceiveRegistrationEmails: boolean;
}

class UserProfile extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: false,
            isDirty: false,
            Validation: false,
            user: undefined,
        }

        this.resetPassword = this.resetPassword.bind(this);
        this.retireUser = this.retireUser.bind(this);
        this.unRetireUser = this.unRetireUser.bind(this);
        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        this.requestUser(this.props.match.params.userId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        if (this.state.user && this.state.user.UserID != nextProps.match.params.userId) {
            this.requestUser(nextProps.match.params.userId);
        }
    }

    public render() {
        return <form>
            <h1>User</h1>
            {this.state.user &&
                <div className="k-form">
                    <DocumentTitle title={this.state.user.UserName || "New User"} />
                    <Prompt when={this.state.isDirty} message="Unsaved changes will be lost, are you sure?" />
                    {this.state.isLoading && <div className="k-loading-image"></div>}
                    <label className="k-form-field">
                        <span>Name</span>
                        <div className="input-group">
                            <input
                                className="form-control"
                                type="text"
                                name="UserFirstName"
                                placeholder="First Name"
                                value={this.state.user.FirstName}
                                onChange={(e) => this.updateUserState({ FirstName: e.target.value })}
                            />
                            <input
                                className="form-control"
                                type="text"
                                name="UesrLastName"
                                placeholder="Last Name"
                                value={this.state.user.LastName}
                                onChange={(e) => this.updateUserState({ LastName: e.target.value })}
                            />
                        </div>
                        {this.state.Validation && !this.state.user.FirstName && !this.state.user.LastName && <p className="error-msg">First and Last Name are Required</p>}
                        {this.state.Validation && !this.state.user.FirstName && this.state.user.LastName && <p className="error-msg">First Name is Required</p>}
                        {this.state.Validation && this.state.user.FirstName && !this.state.user.LastName && <p className="error-msg">Last Name is Required</p>}
                    </label>
                    <label className="k-form-field">
                        <span>User Name</span>
                        <Input
                            type="text"
                            placeholder="User Name"
                            value={this.state.user.UserName}
                            onChange={(e) => this.updateUserState({ UserName: e.target.value.replace(/[^a-zA-Z0-9]/g, "") })}
                        />
                        {this.state.Validation && !this.state.user.UserName && <p className="error-msg">UserName is Required</p>}
                    </label>
                    <label className="k-form-field">
                        <span>Email</span>
                        <Input
                            type="email"
                            placeholder="Email"
                            value={this.state.user.Email}
                            onChange={(e) => this.updateUserState({ Email: e.target.value })}
                        />
                        {this.state.Validation && !this.state.user.Email && <p className="error-msg">Email is Required</p>}
                    </label>
                    <div className="k-form-field">
                        <input
                            type="checkbox"
                            id="admin"
                            className="k-checkbox"
                            checked={this.state.user.IsAdmin}
                            onChange={(e) => this.updateUserState({ IsAdmin: e.target.checked, ReceiveRegistrationEmails: (!e.target.checked) ? false : this.state.user.ReceiveRegistrationEmails })}
                        />
                        <label className="k-checkbox-label" htmlFor="admin">Administrator</label>
                    </div>
                    <div className="k-form-field">
                        <input
                            type="checkbox"
                            id="emails"
                            className="k-checkbox"
                            checked={this.state.user.ReceiveRegistrationEmails}
                            onChange={(e) => this.updateUserState({ ReceiveRegistrationEmails: e.target.checked })}
                            disabled={!this.state.user.IsAdmin}
                        />
                        <label className="k-checkbox-label" htmlFor="emails">Receive Registration Emails</label>
                    </div>
                    <div className="text-right">
                        {this.state.user.IsLockedout && <Button onClick={(e) => confirm("Really un-retire user?") && this.unRetireUser(e)}>Un-Retire User</Button>}
                        {!this.state.user.IsLockedout &&
                            <Button onClick={(e) => confirm("Really retire user?") && this.retireUser(e)}>Retire User</Button>}
                            &nbsp;&nbsp;
                            {this.state.user.UserID !== 'new' && <Button onClick={(e) => confirm('Send password reset email?') && this.resetPassword(e)}>Reset Password</Button>
                        }
                        &nbsp;&nbsp;
                        <LoadingButton 
                            onClick={this.save}
                            disabled={!this.state.isDirty}
                            isLoading={this.state.isLoading}
                            isLoadingText="Saving..."
                            className="btn btn-primary"
                        >
                            {this.state.user.UserID === 'new' ? 'Create' : 'Save'}
                        </LoadingButton>
                    </div>
                </div>
            }
        </form>;
    }

    private updateUserState(value: Partial<UserData>) {
        const user = Object.assign({}, this.state.user, value);
        this.setState({ user, isDirty: true });
    }

    private requestUser(userId: string) {
        if (userId === 'new') {
            const user = {
                UserID: 'new',
                FirstName: '',
                LastName: '',
                UserName: '',
                Phone: '',
                Email: '',
                IsAdmin: false,
                IsLockedout: false,
                ReceiveRegistrationEmails: false,

            } as UserData;
            this.setState({ user });
            return;
        };

        this.setState({ isLoading: true });
        fetchApi(`api/User/Get/${userId}`)
            .then((user: UserData) => {
                this.setState({ isLoading: false, isDirty: false, user });
            });
    }

    private save(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();

        this.setState({ Validation: true });
        if (this.state.user) {
            if (this.state.user.FirstName && this.state.user.LastName && this.state.user.UserName && this.state.user.Email) {
                this.setState({ isLoading: true });
                if (this.state.user.UserID === 'new') {
                    fetchApi(`api/User/Create/`, this.state.user, 'POST')
                        .then((response: { UserID: string }) => {
                            this.updateUserState({ UserID: response.UserID });
                            this.setState({ isLoading: false, isDirty: false });

                            this.props.history.push("/users");
                        });
                } else {
                    fetchApi(`api/User/Save/${this.state.user.UserID}`, this.state.user, 'POST')
                        .then(() => {
                            this.setState({ isLoading: false, isDirty: false });
                        })
                }
            }
        }
    }

    private resetPassword(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();

        if (this.state.user) {
            fetchApi(`api/User/SendResetPassword/${this.state.user.UserID}`, {}, 'POST')
                .then(() => {
                    alert("Password Reset Email Sent!");
                });
        }
    }

    private retireUser(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();

        if (this.state.user) {
            fetchApi(`api/User/Retire/${this.state.user.UserID}`, {}, 'POST')
                .then(() => {
                    this.updateUserState({ IsLockedout: true });
                    alert("User Retired!");
                });
        }
    }

    private unRetireUser(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();

        if (this.state.user) {
            fetchApi(`api/User/UnRetire/${this.state.user.UserID}`, {}, 'POST')
                .then(() => {
                    this.updateUserState({ IsLockedout: false });
                    alert("User Active Again!");
                });
        }
    }
}

export default UserProfile;
